module.exports = __webpack_public_path__ + "static/media/NotFond404.67a66653.jpg";